import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import selectors from '../../../store/shared/selectors'
import emitter from '../../../utils/emitter'
import { setToursAutoStart } from '../../../store/shared/currentUserDuck'
import withFadeInUpAnimation from '../../hocs/withFadeInUpAnimation'
import * as searchHistoryDuck from '../SearchHistory/searchHistoryDuck'

export class PageTitle extends Component {
  static propTypes = {
    content: PropTypes.string,
    tourName: PropTypes.string,
    setToursAutoStart: PropTypes.func.isRequired,
    showHistoryBtn: PropTypes.bool,
    toursAutoStart: PropTypes.arrayOf(PropTypes.string).isRequired,
    isMobile: PropTypes.bool.isRequired,
    performRetrieveMySearchHistory: PropTypes.func.isRequired,
  }

  static defaultProps = {
    content: 'PageTitle',
    showHistoryBtn: false,
    tourName: null,
  }

  constructor(props) {
    super(props)

    this.state = {
      hasDragHandle: window.innerWidth < 800,
    }

    this.handleChangeSidebar = nextHasDragHandle => {
      this.setState({ hasDragHandle: nextHasDragHandle })
    }

    this.openSideBar = () => emitter.emit('SIDEBAR::OPEN')

    this.resetTour = () =>
      this.props.setToursAutoStart(this.props.toursAutoStart.concat([this.props.tourName]))

    this.onHistoryBtnClick = () => {
      this.props.performRetrieveMySearchHistory()
      if (window.searchHistoryPanelAnimation) window.searchHistoryPanelAnimation.play()
    }
  }

  componentDidMount() {
    emitter.on('SIDEBAR::CHANGE', this.handleChangeSidebar)
  }

  componentWillUnmount() {
    emitter.off('SIDEBAR::CHANGE')
  }

  render() {
    const { hasDragHandle } = this.state
    const { children, content, isMobile, showHistoryBtn, tourName } = this.props

    return (
      //Styles in index.css for #page-title
      <div
        className={isMobile ? 'navbar fixed-top shadow' : ''}
        style={{
          backgroundColor: isMobile ? '#fbfbfb' : 'transparent',
          zIndex: 1,
        }}
      >
        <div style={{ display: 'flex', width: '100%' }}>
          <div id="page-title">
            {hasDragHandle && (
              <button id="hamburger" onClick={this.openSideBar}>
                <i className="fal fa-bars" />
              </button>
            )}
            <h1 style={{ marginBottom: 5, paddingRight: 15 }}>{content}</h1>
            {children}
          </div>
          {showHistoryBtn && (
            <div
              className="text-center"
              id="open-history"
              onClick={() => this.onHistoryBtnClick()}
              style={{ cursor: 'pointer', marginRight: !tourName ? 0 : 10 }}
            >
              <i
                style={{ marginTop: isMobile ? 15 : 17, fontSize: 21 }}
                className="fal fa-history"
              />
              <div style={{ fontSize: 10, marginTop: -5 }}>History</div>
            </div>
          )}
          {tourName && (
            <div
              className="text-center shake-on-load"
              onClick={this.resetTour}
              style={{ cursor: 'pointer' }}
              id="start-tour"
            >
              <i
                style={{ marginTop: isMobile ? 15 : 17, fontSize: 21 }}
                className="fal fa-play-circle"
              />
              <div style={{ fontSize: 10, marginTop: -5 }}>Tour</div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  toursAutoStart: selectors.getToursAutoStart(state),
  isMobile: selectors.isLessThanMedium(state),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setToursAutoStart,
      performRetrieveMySearchHistory: searchHistoryDuck.performRetrieveMySearchHistory,
    },
    dispatch,
  )

const withRedux = connect(mapStateToProps, mapDispatchToProps)

export default withRedux(withFadeInUpAnimation(PageTitle))



// WEBPACK FOOTER //
// ./src/components/ui/typography/PageTitle.js